import {
  RESET_CREATE_DOCUMENT_DATA,
  SET_ADDITIONAL_DETAIL_DATA,
  SET_ADVANCE_PAYMENT,
  SET_BANK_DETAILS,
  SET_COMMENT_INPUT_DATA,
  SET_BUYER_DATA,
  SET_DOCUMENT_ADDITIONAL_CHARGES,
  SET_DOCUMENT_ATTACHMENTS_DATA,
  SET_DOCUMENT_FORM_DATA,
  SET_DOCUMENT_ITEM_GRID_DATA,
  SET_DOCUMENT_TO,
  SET_DOCUMENT_TYPE,
  SET_DOCUMENTS_SIGNATURE_DATA,
  SET_DOCUMENTS_TERMS_AND_CONDITION_DATA,
  SET_INDIVIDUAL_DATA,
  SET_LOGISTIC_DETAIL_DATA,
  SET_SUPPLIER_DATA,
  SET_BUYER_SUPPLIER_KYC_DETAIL,
  SET_BATCH_DATA,
} from "../../types/UI/createDocument";

export function setDocumentBuyerData(payload: any) {
  return {
    type: SET_BUYER_DATA,
    payload: payload,
  };
}

export function setDocumentSupplierData(payload: any) {
  return {
    type: SET_SUPPLIER_DATA,
    payload: payload,
  };
}

export function setDocumentType(payload: any) {
  return {
    type: SET_DOCUMENT_TYPE,
    payload: payload,
  };
}

export function setDocumentTo(payload: any) {
  return {
    type: SET_DOCUMENT_TO,
    payload: payload,
  };
}

export function setBankDetails(payload: any) {
  return {
    type: SET_BANK_DETAILS,
    payload: payload,
  };
}

export function setAdvancePaymentData(payload: any) {
  return {
    type: SET_ADVANCE_PAYMENT,
    payload: payload,
  };
}

export function setAdditionalDetailsData(payload: any) {
  return {
    type: SET_ADDITIONAL_DETAIL_DATA,
    payload: payload,
  };
}

export function setCommentInputData(payload: any) {
  return {
    type: SET_COMMENT_INPUT_DATA,
    payload: payload,
  };
}

export function setLogisticDetailsData(payload: any) {
  return {
    type: SET_LOGISTIC_DETAIL_DATA,
    payload: payload,
  };
}

export function setDocumentItemGridData(payload: any) {
  return {
    type: SET_DOCUMENT_ITEM_GRID_DATA,
    payload: payload,
  };
}

export function setAdditionalChargesData(payload: any) {
  return {
    type: SET_DOCUMENT_ADDITIONAL_CHARGES,
    payload: payload,
  };
}

export function setDocumentItemFormData(payload: any) {
  return {
    type: SET_DOCUMENT_FORM_DATA,
    payload: payload,
  };
}

export function setDocumentBatchData(payload: any) {
  return {
    type: SET_BATCH_DATA,
    payload: payload,
  };
}

export function setDocsTermsCondition(payload: any) {
  return {
    type: SET_DOCUMENTS_TERMS_AND_CONDITION_DATA,
    payload: payload,
  };
}

export function setDocumentAttachmentsData(payload: any) {
  return {
    type: SET_DOCUMENT_ATTACHMENTS_DATA,
    payload: payload,
  };
}

export function setDocumentSignatureData(payload: any) {
  return {
    type: SET_DOCUMENTS_SIGNATURE_DATA,
    payload: payload,
  };
}

export const setIndividualData = (payload: any) => {
  return {
    type: SET_INDIVIDUAL_DATA,
    payload: payload,
  };
};
export function setBuyerSupplierKYCDetails(payload: any) {
  return {
    type: SET_BUYER_SUPPLIER_KYC_DETAIL,
    payload: payload,
  };
}

export function resetCreateDocumentData() {
  return {
    type: RESET_CREATE_DOCUMENT_DATA,
  };
}
